
import Button from '../../../components/base/Button';

export default function ProgramsSection() {
  const programs = [
    {
      title: "Education Hub",
      description: "Comprehensive learning resources for healthcare professionals including CE/CPD modules, webinars, and certification programs.",
      icon: "ri-graduation-cap-line",
      image: "https://public.readdy.ai/ai/img_res/8065b930a2e2ee7c49c32a600159d953.jpg"
    },
    {
      title: "Advocacy",
      description: "Strong representation for policy development, regulatory affairs, and professional advancement in healthcare legislation.",
      icon: "ri-megaphone-line", 
      image: "https://readdy.ai/api/search-image?query=Professional%20healthcare%20advocates%20speaking%20at%20government%20building%2C%20policy%20makers%20in%20discussion%2C%20legislative%20environment%2C%20professional%20meeting%20rooms%2C%20advocacy%20and%20policy%20development%20setting&width=400&height=250&seq=adv1&orientation=landscape"
    },
    {
      title: "Community Spotlights",
      description: "Celebrating success stories, innovative practices, and community impact across Canada's healthcare landscape.",
      icon: "ri-community-line",
      image: "https://readdy.ai/api/search-image?query=Diverse%20healthcare%20community%20gathering%2C%20professionals%20celebrating%20achievements%2C%20community%20event%20with%20doctors%20and%20veterinarians%2C%20positive%20healthcare%20environment%2C%20professional%20recognition%20ceremony&width=400&height=250&seq=comm1&orientation=landscape"
    },
    {
      title: "Wellness Academy",
      description: "Holistic wellness programs focusing on mental health, work-life balance, and professional development for healthcare providers.",
      icon: "ri-heart-3-line",
      image: "https://readdy.ai/api/search-image?query=Peaceful%20wellness%20center%20for%20healthcare%20professionals%2C%20meditation%20and%20relaxation%20space%2C%20professional%20wellness%20environment%2C%20calm%20therapeutic%20setting%2C%20healthcare%20worker%20wellbeing%20facility&width=400&height=250&seq=well1&orientation=landscape"
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Programs & Initiatives
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive programs designed to support, educate, and advance healthcare professionals while serving our communities.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {programs.map((program, index) => (
            <div key={index} className="bg-gray-50 rounded-xl overflow-hidden hover:shadow-lg transition-shadow">
              <img
                src={program.image}
                alt={program.title}
                className="w-full h-48 object-cover"
              />
              <div className="p-8">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                    <i className={`${program.icon} text-xl text-blue-600`}></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900">
                    {program.title}
                  </h3>
                </div>
                <p className="text-gray-600 mb-6">
                  {program.description}
                </p>
                <Button variant="outline" size="sm">
                  Learn More
                </Button>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <Button size="lg">
            View All Programs
          </Button>
        </div>
      </div>
    </section>
  );
}
